<template>
  <b-row>
    <b-col cols="12">
      <h1 class="pull-left">Devices</h1>
    </b-col>
    <b-col cols="12">
      <DeviceManagerCollapsableCard
        id="unassignedDevices"
        v-if="canSearchGlobal"
        data-cy="UnassignedDevices"
        title="Unassigned Devices"
        controller="device-manager/device"
        collection="devices"
        add-item-label="Add a device"
        ref="unassignedDevice"
        :include-global-index="true"
        :hide-create-action="true"
        :hide-edit-action="true"
        :hide-delete-action="true"
        @attached="attached"
      ></DeviceManagerCollapsableCard>

      <b-card class="my-3">
        <template #header>
          <div class="d-flex flex-row">
            <h3
              v-b-toggle="collapseAssignedDevicesUID"
              class="flex-grow-1 mb-0 custom-control"
            >
              Assigned Devices
            </h3>
            <b-button variant="outline-primary" @click="createRow">
              <i class="fa fa-plus" />
              Add a device</b-button
            >
          </div>
        </template>
        <b-card-text>
          <b-collapse visible :id="collapseAssignedDevicesUID" class="mt-2">
            <TableView
              v-if="selectedTenant"
              controller="device-manager/device"
              collection="devices"
              title=""
              dataType="device"
              ref="assignedDevicesTable"
              :hideCreateAction="true"
              :index="selectedTenant.index"
            >
            </TableView>
          </b-collapse>
        </b-card-text>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import TableView from '@/components/device-manager/TableView';
import DeviceManagerCollapsableCard from '@/components/device-manager/DeviceManagerCollapsableCard';
import { isActionAllowed } from '@/helpers/rights.js';
import { mapGetters } from 'vuex';

export default {
  components: {
    DeviceManagerCollapsableCard,
    TableView
  },
  data() {
    return {
      tenantDevice: null,
      unassignedDevice: null,
      collapseAssignedDevicesUID: 'collapseAssignedDevicesUID'
    };
  },
  computed: {
    ...mapGetters('auth', ['currentUserRights']),
    canSearchGlobal() {
      return (
        this.currentUserRights &&
        isActionAllowed(
          this.currentUserRights,
          'device-manager/device',
          'search'
        )
      );
    },
    selectedTenant() {
      if (this.$store.getters['tenants/selectedTenant']) {
        return { index: this.$store.getters['tenants/selectedTenant'].index };
      }
      return null;
    }
  },
  methods: {
    isActionAllowed,
    attached: async () => {
      await tenantDevice.value.fetchItems();
    },
    detached: async () => {
      await unassignedDevice.value.fetchItems();
    },
    createRow: () => {
      this.$refs.assignedDevicesTable.createRow();
    }
  }
};
</script>

<style lang="scss">
#unassignedDevices .overflow-auto {
  max-height: 55vh;
  overflow: auto;
}
</style>
